import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Helper } from "src/app/shared/helper";
import { LoaderService } from "./loader.service";

export interface ResponseModel {
  message: string;
  data: any;
  id?: any;
  token?: any;
}

@Injectable({
  providedIn: "root"
})
export class ApiService {
  postApiLoading: boolean = false;
  getApiLoading: boolean = false;
  patchApiLoading: boolean = false;
  putApiLoading: boolean = false;
  deleteApiLoading: boolean = false;

  constructor(private _http: HttpClient, private helper: Helper, public loader: LoaderService) { }

  post({ url, parameters, apiHeaders = null }: { url: string; parameters: any; apiHeaders?: any }): Observable<ResponseModel> {
    this.postApiLoading = true;
    this.loader._isMainLoading = true;
    if (parameters?.isShowLoader === false) {
      this.postApiLoading = false;
      delete parameters.isShowLoader;
    }
    const headers = apiHeaders;
    const baseUrl: any = this.getBaseUrl(url);
    const callUrl: string = baseUrl + url;
    return this._http.post(callUrl, parameters, { headers: headers, observe: "response" }).pipe(
      map((responseData: any) => {
        if (responseData.headers?.get("id")) {
          return { data: responseData.body, message: responseData["message"], id: responseData.headers?.get("id") };
        } else if (responseData.headers?.get("authorization")) {
          return { data: responseData.body, message: responseData["message"], token: responseData.headers?.get("authorization") };
        }
        return { data: responseData.body, message: responseData["message"] };
      }),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        setTimeout(() => {
          if (this.postApiLoading) {
            this.loader._isMainLoading = false;
            this.postApiLoading = false;
          }
        }, 500);
      })
    );
  }

  get({ url, parameters, apiHeaders = null }: { url: string; parameters?: any; apiHeaders?: any }): Observable<ResponseModel> {
    this.loader._isMainLoading = true;
    this.getApiLoading = true;
    if (parameters?.isShowLoader === false) {
      this.getApiLoading = false;
      delete parameters.isShowLoader;
    }
    const headers = apiHeaders;
    const baseUrl: any = this.getBaseUrl(url);
    const callUrl: string = baseUrl + url;

    return this._http.get(callUrl, { params: parameters, headers: headers, observe: "response" }).pipe(
      map((responseData: any) => {
        return { data: responseData.body, message: responseData["message"] };
      }),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        setTimeout(() => {
          if (this.getApiLoading) {
            this.loader._isMainLoading = false;
            this.getApiLoading = false;
          }
        }, 500);
      })
    );
  }

  patch({ url, parameters, apiHeaders = null }: { url: string; parameters: any; apiHeaders?: any }): Observable<ResponseModel> {
    this.loader._isMainLoading = true;
    this.patchApiLoading = true;
    if (parameters?.isShowLoader === false) {
      this.patchApiLoading = false;
      delete parameters.isShowLoader;
    }
    const headers = apiHeaders;
    const baseUrl: any = this.getBaseUrl(url);
    const callUrl: string = baseUrl + url;

    return this._http.patch(callUrl, parameters, { headers: headers, observe: "response" }).pipe(
      map((responseData: any) => {
        return { data: responseData.body, message: responseData["message"] };
      }),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        setTimeout(() => {
          if (this.patchApiLoading) {
            this.loader._isMainLoading = false;
            this.patchApiLoading = false;
          }
        }, 500);
      })
    );
  }

  put({ url, parameters, apiHeaders = null }: { url: string; parameters: any; apiHeaders?: any }): Observable<ResponseModel> {
    this.loader._isMainLoading = true;
    this.putApiLoading = true;
    if (parameters?.isShowLoader === false) {
      this.putApiLoading = false;
      delete parameters.isShowLoader;
    }
    const headers = apiHeaders;
    const baseUrl: any = this.getBaseUrl(url);
    const callUrl: string = baseUrl + url;

    return this._http.put(callUrl, parameters, { headers: headers, observe: "response" }).pipe(
      map((responseData: any) => {
        return { data: responseData.body, message: responseData["message"] };
      }),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        setTimeout(() => {
          if (this.putApiLoading) {
            this.loader._isMainLoading = false;
            this.putApiLoading = false;
          }
        }, 500);
      })
    );
  }

  delete({ url, parameters, apiHeaders = null }: { url: string; parameters: any; apiHeaders?: any }): Observable<ResponseModel> {
    this.loader._isMainLoading = true;
    this.deleteApiLoading = true;
    if (parameters?.isShowLoader === false) {
      this.deleteApiLoading = false;
      delete parameters.isShowLoader;
    }
    const headers = apiHeaders;
    const baseUrl: any = this.getBaseUrl(url);
    const callUrl: string = baseUrl + url;

    return this._http.delete(callUrl, { headers: headers, body: parameters, observe: "response" }).pipe(
      map((responseData: any) => {
        return { data: responseData.body, message: responseData["message"] };
      }),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        setTimeout(() => {
          if (this.deleteApiLoading) {
            this.loader._isMainLoading = false;
            this.deleteApiLoading = false;
          }
        }, 500);
      })
    );
  }

  getBaseUrl(url: any): string {
    return environment.API_URL;
  }
}
